<script>
import Layout from '@/Shared/layout/editor'

export default {
  layout: (h, page) => h(Layout, [page]),
  layout: Layout,
}
</script>

<script setup>
import { ref, onBeforeUnmount } from 'vue';
import { Editor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';

defineProps({ user: Object, pages: Object, sites: Object, categories: Object});

const editor = ref(new Editor({
  extensions: [
    StarterKit,
  ],
  content: `<p>Hello Tiptap!</p>`,
}));

onBeforeUnmount(() => {
  editor.value.destroy();
});
</script>

<template>
<div class="m-8">
<h1 class="text-2xl font-semibold">Page - name</h1>
<editor-content :editor="editor" />



</div>



</template>